/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 필터 버튼을 모아놓은 필터 바
 * 버전 : 1.0
 * 파일명 : FilterBarInterested.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-07-17
 * ================================================================ 

 *=================================================================
 */

import styled from 'styled-components'
import { Icon_ArrowDown } from '../common/CommonIcons'
import DialogInterestBirthday from './DialogInterestBirthday'
import { usePromoDialogInterest } from 'src/stores/PromoStore'
import DialogInterestCouncelday from './DialogInterestCouncelday'
import DialogInterestGender from './DialogInterestGender'
import DialogInterestStatus from './DialogInterestStatus'

const PageWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;

  height: 33px;
  font-size: 14px;
  font-weight: 400;
`

const ElementWrapper = styled.div`
  display: flex;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  gap: 6px;

  border-radius: 100px;
  border: 1px solid #ddd;
  white-space: nowrap;
`
interface Props{
  result_id:number,
  school_class:string
}

const FilterBarPromoInterested = ({result_id, school_class}:Props) => {
  const setField = usePromoDialogInterest((state) => state.setField);
  const onClickBirthday = ()=>{
    setField('element',<DialogInterestBirthday result_id={result_id} school_class={school_class}/>)
    setField('isOpen',true)
  }

  const onClickCouncelday = ()=>{
    setField('element',<DialogInterestCouncelday result_id={result_id} school_class={school_class}/>)
    setField('isOpen',true)
  }

  const onClickGender = ()=>{
    setField('element',<DialogInterestGender result_id={result_id} school_class={school_class}/>)
    setField('isOpen',true)
  }

  const onClickStatus = ()=>{
    setField('element',<DialogInterestStatus result_id={result_id} school_class={school_class}/>)
    setField('isOpen',true)
  }

  return (
    <PageWrapper>
      <ElementWrapper onClick={onClickBirthday}>
        생년월일
        <Icon_ArrowDown style={{color:'#969696', fontSize:'16px'}}/>
      </ElementWrapper>
      <ElementWrapper onClick={onClickCouncelday}>
        상담일
        <Icon_ArrowDown style={{color:'#969696', fontSize:'16px'}}/>
      </ElementWrapper>
      <ElementWrapper onClick={onClickGender}>
        성별
        <Icon_ArrowDown style={{color:'#969696', fontSize:'16px'}}/>
      </ElementWrapper>
      <ElementWrapper onClick={onClickStatus}>
        상태
        <Icon_ArrowDown style={{color:'#969696', fontSize:'16px'}}/>
      </ElementWrapper>
    </PageWrapper>
  )
}

export default FilterBarPromoInterested